﻿var GoogleScriptsService = {
    addTagManager: function (id) {
        addScriptOnHead(`(function (w, d, s, l, i) {
                w[l] = w[l] || []; w[l].push({
                'gtm.start':
                    new Date().getTime(), event: 'gtm.js'
            }); var f = d.getElementsByTagName(s)[0],
                j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src =
                    '//www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f);
        })(window, document, 'script', 'dataLayer', '${id}');`);
    },
    addOptmise: function (analyticsId, optmiseId) {
        //addScriptOnHead(`(function (i, s, o, g, r, a, m) {
        //    i['GoogleAnalyticsObject'] = r; i[r] = i[r] || function () {
        //        (i[r].q = i[r].q || []).push(arguments)
        //    }, i[r].l = 1 * new Date(); a = s.createElement(o),
        //        m = s.getElementsByTagName(o)[0]; a.async = 1; a.src = g; m.parentNode.insertBefore(a, m)
        //})(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');

        //ga('create', '${analyticsId}', 'auto');
        //ga('require', '${optmiseId}');`);
    },
    addConversionPage: function (paymentAmount) {
        addScriptOnBody(`gtag('event', 'conversion', {
            'send_to': 'AW-1071972399/zlivCL7EpLoBEK-AlP8D',
            'value': ${paymentAmount},
            'currency': 'GBP',
            'transaction_id': ''
        });`);
    },
    //commented as it was causing page flickers
    addAntiFlicker: function (id) {
        //addScriptOnHead(`(function(a,s,y,n,c,h,i,d,e){s.className += ' ' + y; h.start=1*new Date;
        //        h.end=i=function(){s.className = s.className.replace(RegExp(' ?' + y), '')};
        //        (a[n]=a[n]||[]).hide=h;setTimeout(function(){i(); h.end=null},c);h.timeout=c;
        //        })(window,document.documentElement,'async-hide','dataLayer',4000,{'${id}': true});`);
    },
    consentGranted: function () {
        gtag('consent', 'update', {
            'ad_storage': 'granted',
            'analytics_storage': 'granted',
            'security_storage': 'granted'
        });

        addScriptOnHead(`window.dataLayer.push({
                'event': 'cookieConsent',
                'consentStatus': true
                })`);

    },
    consentRevoked: function () {
        gtag('consent', 'update', {
            'ad_storage': 'denied',
            'analytics_storage': 'denied',
            'security_storage': 'granted'
        });

        addScriptOnHead(`window.dataLayer.push({
                'event': 'cookieConsent',
                'consentStatus': false
                })`);

    },
    pushEvent: function (event) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(event);
    }
}

var FacebookScriptsService = {
    addFacebookTracking: function (isSearch) {
        addScriptOnBodyTop(`!function (f, b, e, v, n, t, s) {
                if (f.fbq) return; n = f.fbq = function () {
                    n.callMethod ?
                        n.callMethod.apply(n, arguments) : n.queue.push(arguments)
                };
                if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0';
                n.queue = []; t = b.createElement(e); t.async = !0;
                t.src = v; s = b.getElementsByTagName(e)[0];
                s.parentNode.insertBefore(t, s)
            }(window, document, 'script',
                'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '1755089831374739');
            fbq('track', 'PageView');`);
    },
    addFacebookEvent: function (event) {
        addScriptOnBody(`fbq('track', '${event}');`);
    },
    getFbq: function () {
        return fbq;
    }
}

var BingScriptsService = {
    addBingTracking: function () {
        addScriptOnBody(`(function (w, d, t, r, u) { var f, n, i; w[u] = w[u] || [], f = function () { var o = { ti: "5296147" }; 
                        o.q = w[u], w[u] = new UET(o), w[u].push("pageLoad") }, n = d.createElement(t), n.src = r, n.async = 1, n.onload = n.onreadystatechange = function () {
                            var s = this.readyState; s && s !== "loaded" && s !== "complete" || (f(), n.onload = n.onreadystatechange = null) }, i = d.getElementsByTagName(t)[0], i.parentNode.insertBefore(n, i)
                        })(window, document, "script", "//bat.bing.com/bat.js", "uetq");`)
    }
}

var addScriptOnHead = function (script) {
    document.head.appendChild(createScriptElement(script));
}

var addScriptOnBody = function (script) {
    document.body.appendChild(createScriptElement(script));
}


var addScriptOnBodyTop = function (script) {
    document.body.insertBefore(createScriptElement(script), document.body.firstChild);
}

function createScriptElement(script) {
    var addDataLayer = document.createElement("script");

    var dataLayerData = document.createTextNode(script);

    addDataLayer.appendChild(dataLayerData);
    return addDataLayer;
}

export { GoogleScriptsService, FacebookScriptsService, BingScriptsService }